import WorkflowActionTypes from './types';
import { CollectionItem, CollectionEnums, ScheduledCount } from './contracts';

export const fetchDocketDataStart = (code: string) => ({
  type: WorkflowActionTypes.FETCH_DOCKET_DATA_START,
  payload: code,
});

export const saveCollectionStart = (payload: any) => ({
  type: WorkflowActionTypes.SAVE_COLLECTION_START,
  payload,
});

export const saveDocketStart = (payload: any) => ({
  type: WorkflowActionTypes.SAVE_DOCKET_START,
  payload,
});

export const fetchDocketDataSuccess = (data: any) => ({
  type: WorkflowActionTypes.FETCH_DOCKET_DATA_SUCCESS,
  payload: data,
});

export const saveCollectionSuccess = (data: any) => ({
  type: WorkflowActionTypes.SAVE_COLLECTION_SUCCESS,
  payload: data,
});

export const saveDocketSuccess = (data: any) => ({
  type: WorkflowActionTypes.SAVE_DOCKET_SUCCESS,
  payload: data,
});

export const fetchDocketDataFailure = (errorMessage: any) => ({
  type: WorkflowActionTypes.FETCH_DOCKET_DATA_FAILURE,
  payload: errorMessage,
});

export const fetchCollectionEnums = () => ({
  type: WorkflowActionTypes.FETCH_COLLECTION_ENUMS,
});

export const fetchFilters = () => ({
  type: WorkflowActionTypes.FETCH_FILTERS_START,
});

export const fetchFiltersSuccess = (data: any) => ({
  type: WorkflowActionTypes.FETCH_FILTERS_SUCCESS,
  payload: data,
});

export const fetchCollectionEnumsSuccess = (data: CollectionEnums) => ({
  type: WorkflowActionTypes.FETCH_COLLECTION_ENUMS_SUCCESS,
  payload: data,
});

export const fetchScheduledMapData = (argArr: Array<string>) => ({
  type: WorkflowActionTypes.FETCH_SCHEDULED_MAP,
  payload: argArr,
});

export const getCurrentLocation = (argArr: Array<string>) => ({
  type: WorkflowActionTypes.GET_CURRENT_LOCATION_START,
  payload: argArr,
});

export const deleteDocketStart = (argArr: Array<string>) => ({
  type: WorkflowActionTypes.DELETE_DOCKET_START,
  payload: argArr,
});

export const deleteInvoiceStart = (invoiceId: any) => ({
  type: WorkflowActionTypes.DELETE_INVOICE_START,
  payload: invoiceId,
});

export const fetchScheduledItenaryStart = (argArr: Array<string>) => ({
  type: WorkflowActionTypes.FETCH_SCHEDULED_ITENARY_START,
  payload: argArr,
});

export const resetSnackBar = () => ({
  type: WorkflowActionTypes.RESET_SNACKBAR,
});

export const deleteTripStart = (argArr: Array<string>) => ({
  type: WorkflowActionTypes.DELETE_TRIP_START,
  payload: argArr,
});

export const deleteTripSuccess = (data: any) => ({
  type: WorkflowActionTypes.DELETE_TRIP_SUCCESS,
  payload: data,
});

export const fetchScheduledItenarySuccess = (data: any) => ({
  type: WorkflowActionTypes.FETCH_SCHEDULED_ITENARY_SUCCESS,
  payload: data,
});

export const getCurrentLocationSuccess = (data: any) => ({
  type: WorkflowActionTypes.GET_CURRENT_LOCATION_SUCCESS,
  payload: data,
});

export const fetchScheduledMapDataSuccess = (data: any) => ({
  type: WorkflowActionTypes.FETCH_SCHEDULED_MAP_SUCCESS,
  payload: data,
});

export const deleteDocketSuccess = (data: any) => ({
  type: WorkflowActionTypes.DELETE_DOCKET_SUCCESS,
  payload: data,
});

export const deleteInvoiceSuccess = (data: any) => ({
  type: WorkflowActionTypes.DELETE_INVOICE_SUCCESS,
  payload: data,
});

export const fetchCollectionDataStart = (code: string) => ({
  type: WorkflowActionTypes.FETCH_COLLECTION_DATA_START,
  payload: code,
});

export const findConsignee = (code: string) => ({
  type: WorkflowActionTypes.FIND_CONSIGNEE,
  payload: code,
});

export const findConsigneeSuccess = (data: any) => ({
  type: WorkflowActionTypes.FIND_CONSIGNEE_SUCCESS,
  payload: data,
});

export const fetchCollectionDataSuccess = (data: CollectionItem) => ({
  type: WorkflowActionTypes.FETCH_COLLECTION_DATA_SUCCESS,
  payload: data,
});

export const fetchScheduledVehiclesStart = (argArr: Array<string>) => ({
  type: WorkflowActionTypes.FETCH_SCHEDULED_VEHICLES_START,
  payload: argArr,
});

export const fetchPathDetailStart = (argArr: Array<string>) => ({
  type: WorkflowActionTypes.FETCH_PATH_DETAIL_START,
  payload: argArr,
});

export const validateActionTimeStart = (argArr: Array<string>) => ({
  type: WorkflowActionTypes.VALIDATE_ACTION_TIME,
  payload: argArr,
});

export const updateConsignmentStart = (argArr: any) => ({
  type: WorkflowActionTypes.UPDATE_CONSIGNMENT,
  payload: argArr,
});

export const updateConsignmentSuccess = (data: any) => ({
  type: WorkflowActionTypes.UPDATE_CONSIGNMENT_SUCCESS,
  payload: data,
});

export const validateActionTimeSuccess = (data: any) => ({
  type: WorkflowActionTypes.VALIDATE_ACTION_TIME_SUCCESS,
  payload: data,
});

export const fetchPathDetailSuccess = (data: any) => ({
  type: WorkflowActionTypes.FETCH_PATH_DETAIL_SUCCESS,
  payload: data,
});

export const fetchScheduledVehiclesSuccess = (data: any) => ({
  type: WorkflowActionTypes.FETCH_SCHEDULED_VEHICLES_SUCCESS,
  payload: data,
});

export const fetchScheduledCountStart = (argArr: any) => ({
  type: WorkflowActionTypes.FETCH_SCHEDULED_COUNT_START,
  payload: argArr,
});

export const fetchScheduledCountSuccess = (data: ScheduledCount) => ({
  type: WorkflowActionTypes.FETCH_SCHEDULED_COUNT_SUCCESS,
  payload: data,
});

export const resetPathItenaryData = () => ({
  type: WorkflowActionTypes.RESET_PATH_ITENARY_DATA,
});
